export const PAGE_POSITION_TYPE = {
  FRONT: "Front",
  BACK: "Back",
  LEFT: "Left",
  RIGHT: "Right",
};



// WEBPACK FOOTER //
// ./src/common/interfaces/page.interface.js